export default __webpack_public_path__ + "static/media/not-found.7cd51409.jpg";